import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_SYSTEM_SETTINGS } from '../apollo/queries/settingsQueries';
import './css/MaintenancePage.css';

const MaintenancePage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { data: settingsData, loading } = useQuery(GET_SYSTEM_SETTINGS);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (loading) {
    return (
      <div className="maintenance-loading">
        <div className="loading-spinner"></div>
        <p>로딩 중...</p>
      </div>
    );
  }

  const settings = settingsData?.getSystemSettings;
  const maintenanceImage = isMobile 
    ? settings?.mobileMaintenanceImage 
    : settings?.desktopMaintenanceImage;

  return (
    <div className="maintenance-container">
      {maintenanceImage ? (
        <div className="maintenance-image-container">
          <img 
            src={maintenanceImage} 
            alt="사이트 점검 중" 
            className="maintenance-image"
          />
        </div>
      ) : (
        <div className="maintenance-text-container">
          <div className="maintenance-content">
            <div className="maintenance-icon">
              <div className="gear-icon">
                <div className="gear">⚙️</div>
                <div className="gear gear-small">⚙️</div>
              </div>
            </div>
            <h1 className="maintenance-title">사이트 점검 중입니다</h1>
            <p className="maintenance-subtitle">
              더 나은 서비스 제공을 위해 시스템 점검을 진행하고 있습니다.
            </p>
            <div className="maintenance-details">
              <p>잠시 후 다시 이용해 주시기 바랍니다.</p>
              <p>이용에 불편을 드려 죄송합니다.</p>
            </div>
            <div className="contact-info">
              <p>문의사항이 있으시면 고객센터로 연락해 주세요.</p>
              <div className="contact-details">
                <span>📞 1588-0000</span>
                <span>✉️ info@busbarworld.com</span>
              </div>
            </div>
            <div className="maintenance-animation">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaintenancePage; 